import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 7% 7% 0;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	min-width: 350px;
`;

export const RecordWraper = styled.div`
	padding: 8% 0 0 0;
	#logs_title {
		font-size: 14px;
		letter-spacing: 0.3px;
		color: ${colors.grey5};
		padding: 0 0 5px 0;
	}
`;


export const Row = styled.div`
	display: flex;
	height: 48px;
	padding: 0 12px;
	align-items: center;
	border-top: 1px solid ${colors.grey4};
	background-color: white;

	&:last-child {
		border-bottom: 1px solid ${colors.grey4};
	}
`;

export const Label = styled.div`
	font-size: 16px;
	line-height: 24px;
	padding: 0 16px;
	color: ${colors.grey8};
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const ModalBody = styled.div`
	text-align: center;
	margin: 2px;
`;